<nav class="navbar">
    <div class="container-fluid gap-2">
        <div class="navbar-brand" routerLink="/" >
            <span class="lga-name" >
                {{lgaName}}
            </span>
        </div>

        <div class="ms-auto d-flex gap-4 align-items-center">
            <div class="dropdown-container" role="button">
                <div class="user-data toggle" data-bs-toggle="dropdown">
                    <img src="/assets/images/user-avatar.png" alt="" class="profile-pic">
                    <span class="username d-none d-md-block">{{user?.displayName?.toUpperCase()}}</span>
                    <span class="material-symbols-outlined">
                        keyboard_arrow_down
                    </span>
                </div>
                <div class="dropdown-menu amc-table-action-select">
                    <div class="dropdown-wrapper">
                        
                        <div class="action-btn" role="button"
                            (click)="logout()">
                            <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px"><path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h280v80H200Zm440-160-55-58 102-102H360v-80h327L585-622l55-58 200 200-200 200Z"/></svg>
                            Logout
                        </div>
                    </div>
                </div>
            </div>

            

            <span role="button" class="material-symbols-outlined d-block d-lg-none" (click)="toggleSideNav()">{{isSideNavOpen ? 'close' : 'menu'}}</span>
            
        </div>

    </div>
</nav>